// Dependencies
import isEmail from 'validator/lib/isEmail';
import isMobilePhone from 'validator/es/lib/isMobilePhone';

const referYourFriend = (formData) => {
  const firstName = formData?.firstName;
  const lastName = formData?.lastName;
  const email = formData?.email;
  const telephone = formData?.telephone;
  const referredBy = formData?.referredBy;
  const referAFriend = formData?.referAFriend;

  const output = {
    errors: {},
    success: false,
  };

  if (!firstName || firstName === '')
    output.errors.firstName = 'Please enter your first name.';

  if (!lastName || lastName === '')
    output.errors.lastName = 'Please enter your last name.';

  if (!email || email === '')
    output.errors.email = 'Please enter your email address.';
  else if (!isEmail(email))
    output.errors.email = 'Please enter a valid email address.';

  if (!telephone || telephone === '')
    output.errors.telephone = 'Please enter your telephone number.';
  else if (!isMobilePhone(telephone))
    output.errors.telephone = 'Please enter a valid telephone number.';

  if (!referredBy || referredBy === 'referredBy')
    output.errors.referredBy = 'Please enter who you were referred by.';

  if (referAFriend) {
    if (
      referAFriend !== 'Wishes to Remain Anonymous' &&
      referAFriend !== 'Happy for Friend to Know' &&
      referAFriend !== 'Own Details'
    )
      output.errors.referAFriend = 'Please select a valid option.';
  }

  if (Object.keys(output?.errors).length === 0) {
    output.success = true;
  }

  return output;
};

export default referYourFriend;
